import Footer from './Footer'
import Header from './Header'
import Nav from './Nav'
export { Footer, Header, Nav }



// WEBPACK FOOTER //
// ./src/view/pc/homePage/components/common/index.js